import script from "./AsesoriaLegalPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaLegalPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaLegalPrivadoView.vue?vue&type=style&index=0&id=f48cda84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f48cda84"]])

export default __exports__